// Shared pieces of the property page's design (Sam's): the card, its label,
// the quiet pill action, and the hint line. Extracted so the at-a-glance
// section reuses them rather than restating the values.
import styled from "styled-components";

export const Card = styled.section`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
`;

export const CardLabel = styled.div`
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6b7280;
  margin-bottom: 14px;
`;

export const QuietAction = styled.a`
  font-size: 0.9rem;
  font-weight: 600;
  border-radius: 999px;
  padding: 8px 18px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  text-decoration: none;
  cursor: pointer;
  border: 1px solid #d1d5db;
  color: #1a1a1a;
  background: #ffffff;

  &:hover {
    background: #f3f4f6;
    color: #1a1a1a;
  }
`;

export const HintText = styled.p`
  font-size: 0.85rem;
  color: #6b7280;
  margin: 10px 0 0;
`;
